import Badge from '../ui/Badge'

const getEnvName = (): string | null => {
  const hostname = location.hostname

  if (hostname.includes('localhost')) return 'dev'

  const subdomains = hostname.split('.')

  if (subdomains.length <= 2) return null

  return subdomains[0]
}

export function EnvBadge() {
  const envName = getEnvName()

  if (!envName) return null

  return (
    <div className="fixed top-[2px] left-[-24px] -rotate-45 z-[999999]">
      <Badge
        variant="neutral"
        className="min-w-20 min-h-7 bg-red-500 text-white shadow-md rounded-md font-semibold"
      >
        <p className="w-full text-center">{envName}</p>
      </Badge>
    </div>
  )
}
